function fnPageLoaded() {
	/*
	*	Page loaded
	 */
	if($('section.preloader').length > 0){
		setTimeout(function(){
		  $( 'body' ).addClass( 'page-loaded' );
		}, 2000);
	}else{
		$( 'body' ).addClass( 'page-loaded' );
	}
}
